<template>
    <div class="fund">
         <div class="section-content content-box">
             <div class="title" style="font-size:83px;width: 300px;line-height: 76px;">Public  Welfare  Undertaking </div>
             <p class="title" style="margin-top:34px;font-size: 42px;">公益事业</p>
             <div class="content" style="width:720px;">思可国际教育集团、七田真国际教育CEO马思延，早年就读于杨陵区张家岗小学和杨陵中学。出于对母校的培育之情，2008年，他和杨凌示范区慈善协会成立了“思可助学基金”，用于资助两校品学兼优、家庭困难的学生。</div>
             <div class="content">2017年9月，马思延又和杨凌示范区慈善协会签定了“实施项目基金五年协议”，资助面更宽更广，资助力度更大，投入资金总量达50万元以上，并将“思可助学基金”更名为“思可爱心基金”</div>
             <div class="content">2018年，思可爱心基金获得陕西省第二届“三秦善星”荣誉称号。</div>
             <div class="content">2019年，思可爱心基金启动全新项目——“爱心1+1”，其中包含七田真老师+当地幼儿园老师、学术专家+当地教育工作者、爱心会员家庭+当地贫困家庭，助力教育慈善，携手更多爱心家庭同行。</div>
             <img src="../../assets/imgs/foot-page/fund-min.png" >
         </div>
        <div class="section-content" style="border-bottom: 1px solid #cecece;">
            <div style="width: 1100px;margin: 50px auto;">
                <video
                        id="myVideo"
                        class="video-js"
                >
                    <source
                            src="../../assets/imgs/wisdom.mp4"
                            type="video/mp4"
                    >
                </video>
            </div>
        </div>
        <div class="section-content" style="position: relative;">
            <div class="title" style="margin: 14px 0px 20px;">公益事业·足迹 </div>
            <img class="btns" @click="btnFn(prev)" style="right:0px;" src="../../assets/imgs/foot-page/fund-next.png" />
            <img class="btns" @click="btnFn(next)" style="left:0px;" src="../../assets/imgs/foot-page/fund-prev.png" />

            <div class="lun-box">
                <div :style="{width:'2322px',transform: 'translateX('+(-num*258)+'px)'}">
                    <img v-for="item in imgArr" :src="item" />
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    export default {
        data(){
            return{
                num: 0,
                imgArr:[
                    require('../../assets/imgs/foot-page/fund-1.png'),
                    require('../../assets/imgs/foot-page/fund-2.png'),
                    require('../../assets/imgs/foot-page/fund-3.png'),
                    require('../../assets/imgs/foot-page/fund-4.png'),
                    require('../../assets/imgs/foot-page/fund-5.jpg'),
                    require('../../assets/imgs/foot-page/fund-6.jpg'),
                    require('../../assets/imgs/foot-page/fund-7.jpg'),
                    require('../../assets/imgs/foot-page/fund-8.jpg'),
                    // require('../../assets/imgs/foot-page/fund-9.jpg'),
                ]
            }
        },
        mounted() {
            this.initVideo();
        },
        methods: {
            initVideo() {
                //初始化视频方法
                let myPlayer = this.$video(myVideo, {
                    //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
                    controls: true,
                    //自动播放属性,muted:静音播放
                    // autoplay: "muted",
                    //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
                    preload: "auto",
                    //设置视频播放器的显示宽度（以像素为单位）
                    width: "1100px",
                    //设置视频播放器的显示高度（以像素为单位）
                    height: "600px"
                });
            },
            btnFn(type){
                if(type=='prev'){
                    this.num++;
                    this.num>4?this.num=0:this.num;
                }else{
                    this.num--;
                    this.num<0?this.num=4:this.num;
                }
            }
        }
    }
</script>
<style lang="less" scoped>
    .fund{
        font-size: 16px;
        color: #777777;
        .title{
            color: #3346ab;
            font-weight: 600;
            font-size: 25px;
        }
        .content-box{
            background: url("../../assets/imgs/foot-page/fund-max.png") no-repeat;
            background-position: 226% 50%;
            background-size: 70%;
            padding-top: 110px;
            position: relative;
            img{
                position: absolute;
                bottom: 20px;
                left: 700px;
                width: 258px;
            }
        }
        .content{margin: 26px 0px;line-height: 30px;width:600px;}
          .btns{
              position: absolute;
              top: 108px;
              width: 46px;
              cursor: pointer;
          }
        .lun-box{
            width:1000px;
            height:150px;
            /*border:1px solid red;*/
            margin: 30px auto 70px;
            overflow: hidden;
            position: relative;


            div{
                img{
                    width: 226px;
                    height: 150px;
                    margin-right: 32px;
                }
            }

        }
    }
</style>
